"use client";
import {
  __name
} from "../../../chunk-SHUYVCID.js";

// src/sections/core/contact/contact-minimal.tsx
import { Icon } from "@core/icons";
import { Button } from "@core/ui/components/atoms/button";
import { Input } from "@core/ui/components/atoms/input";
import { Label } from "@core/ui/components/atoms/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@core/ui/components/atoms/select";
import { Textarea } from "@core/ui/components/atoms/textarea";
import { useState } from "react";
import { isMessageField } from "../../../content/helpers.js";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_MINIMAL_FIELDS = [
  { id: "name", label: "Name", type: "text", placeholder: "Your name", required: true },
  { id: "email", label: "Email", type: "email", placeholder: "your@email.com", required: true },
  { id: "message", label: "Message", type: "text", placeholder: "How can we help\
?", required: true }
];
function MinimalFieldInput({ field, isMessage }) {
  if (field.type === "select" && field.options != null) {
    return /* @__PURE__ */ jsxs(Select, { name: field.id, ...field.required !== void 0 &&
    { required: field.required }, children: [
      /* @__PURE__ */ jsx(SelectTrigger, { id: field.id, children: /* @__PURE__ */ jsx(
      SelectValue, { placeholder: field.placeholder ?? `Select ${field.label}` }) }),
      /* @__PURE__ */ jsx(SelectContent, { children: field.options.map((option) => /* @__PURE__ */ jsx(
      SelectItem, { value: option, children: option }, option)) })
    ] });
  }
  if (isMessage) {
    return /* @__PURE__ */ jsx(
      Textarea,
      {
        id: field.id,
        name: field.id,
        placeholder: field.placeholder,
        required: field.required,
        rows: 4
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Input,
    {
      id: field.id,
      name: field.id,
      type: field.type,
      placeholder: field.placeholder,
      required: field.required
    }
  );
}
__name(MinimalFieldInput, "MinimalFieldInput");
function ContactMinimal({ content, themeId }) {
  const [submitted, setSubmitted] = useState(false);
  if (content == null) {
    return null;
  }
  const { formConfig } = content;
  const fields = formConfig?.fields ?? DEFAULT_MINIMAL_FIELDS;
  const submitText = formConfig?.submitText ?? "Send Message";
  const successMessage = formConfig?.successMessage ?? "Thank you! We'll be in t\
ouch soon.";
  function handleSubmit(e) {
    e.preventDefault();
    if (formConfig?.formAction != null) {
      e.target.submit();
      return;
    }
    setSubmitted(true);
  }
  __name(handleSubmit, "handleSubmit");
  if (submitted) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex items-center gap-3 rounded-lg border border-primary/20 \
bg-primary/5 px-4 py-3 text-sm text-primary",
        "data-theme": themeId,
        children: [
          /* @__PURE__ */ jsx(Icon, { icon: "Check", className: "size-4 shrink-0" }),
          successMessage
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "form",
    {
      onSubmit: handleSubmit,
      action: formConfig?.formAction,
      method: formConfig?.formAction != null ? "POST" : void 0,
      className: "flex flex-col gap-4",
      "data-theme": themeId,
      children: [
        fields.map((field) => {
          const isMessage = isMessageField(field.id);
          return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5",
          children: [
            /* @__PURE__ */ jsxs(Label, { htmlFor: field.id, className: "text-sm",
            children: [
              field.label,
              field.required === true && /* @__PURE__ */ jsx("span", { className: "\
ml-0.5 text-primary", "aria-hidden": "true", children: "*" })
            ] }),
            /* @__PURE__ */ jsx(MinimalFieldInput, { field, isMessage })
          ] }, field.id);
        }),
        /* @__PURE__ */ jsx(Button, { type: "submit", className: "mt-1 w-full", children: submitText })
      ]
    }
  );
}
__name(ContactMinimal, "ContactMinimal");
export {
  ContactMinimal
};
